import api from './api'
import { extractPushTokensArray } from '../utils/pushTokensResponse'

/**
 * Push Notifications — gestión de notificaciones push (FCM).
 */
export const pushNotificationService = {
  /**
   * Registrar token de dispositivo
   * 
   * @param {Object} data - Datos del dispositivo
   * @param {string} data.token - Token FCM (required, max:500)
   * @param {string} data.device_id - ID único del dispositivo (nullable, max:255)
   * @param {string} data.platform - Plataforma: 'android', 'ios', 'web' (required)
   * @param {string} data.app_version - Versión de la app (nullable, max:50)
   * @param {string} data.device_model - Modelo del dispositivo (nullable, max:100)
   * @param {string} data.os_version - Versión del SO (nullable, max:50)
   * @returns {Promise<Object>} Respuesta del backend
   */
  async register(data) {
    const response = await api.post('/push/register', data)
    return response.data
  },

  /**
   * Desactivar token de dispositivo
   * 
   * @param {string} token - Token FCM a desactivar (required)
   * @returns {Promise<Object>} Respuesta del backend
   */
  async unregister(token) {
    const response = await api.delete('/push/unregister', {
      data: { token }
    })
    return response.data
  },

  /**
   * Listar tokens del usuario autenticado
   *
   * Normaliza el cuerpo: `data` queda siempre como array de tokens aunque el backend
   * devuelva `{ data: { data: [...] } }`, `tokens`, paginación, etc.
   *
   * @returns {Promise<Object>} { success?, data: [...], ...resto del backend }
   */
  async getTokens() {
    const response = await api.get('/push/tokens')
    const body = response.data
    const list = extractPushTokensArray(body)
    return {
      ...body,
      data: list,
      success: body?.success !== false
    }
  },

  /**
   * Enviar notificación de prueba
   * 
   * @param {Object} data - Datos de la notificación
   * @param {string} data.titulo - Título de la notificación (required, max:255)
   * @param {string} data.mensaje - Mensaje de la notificación (required)
   * @param {string} data.prioridad - Prioridad: 'BAJA', 'MEDIA', 'ALTA', 'URGENTE' (nullable)
   * @returns {Promise<Object>} Respuesta del backend
   */
  async test(data) {
    const response = await api.post('/push/test', data)
    return response.data
  },
}

